<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

// Routes can opt in to using the full viewport width via `meta.fullWidth`,
// bypassing the default centered max-w-5xl container.
const useFullWidth = computed(() => Boolean(route.meta?.fullWidth));
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 bg-n-surface-1"
    :class="useFullWidth ? 'overflow-hidden' : 'pb-8 pt-4 px-6 overflow-auto'"
  >
    <div
      class="flex items-start w-full mx-auto"
      :class="useFullWidth ? 'max-w-none flex-1 min-h-0' : 'max-w-5xl'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
